import React, { useRef } from "react";
import { useSelector } from "react-redux";
import CircularButton from "../../../../components/common/MainButton/CircularButton";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation } from 'swiper/modules';
import PriceCard from "../../../../components/common/PriceCard/PriceCard";
import { useLocation } from "react-router-dom";
import { getPricingPlan } from "../../../../data/pricingPlans";

const PricingSlider = ({ showheading }) => {
  // const getFreePackageDetail = useSelector((plan) =>
  //   plan?.PricingPlanReducer.find((item) => item.name === "FREE")
  // );
  const getBusinessPackageDetail = useSelector((plan) =>
    plan?.PricingPlanReducer.find((item) => item.name === "BUSINESS")
  );
  const getPremiumPackageDetail = useSelector((plan) =>
    plan?.PricingPlanReducer.find((item) => item.name === "PREMIUM")
  );
  const swiperRef = useRef();
  const location = useLocation();
  
  // Get pricing plan data
  const basicPlan = getPricingPlan('basic');
  const proPlan = getPricingPlan('pro');
  return (
    <>
    <div>
      <Swiper
        className="w-[300px] sm:w-[350px] 2xl:w-[450px]"
        slidesPerView={1}
        loop
        speed={500}
        spaceBetween={20}
        modules={[Pagination, Navigation]}
        onBeforeInit={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        <SwiperSlide>
          <PriceCard
            bottomLine={"border-b border-b-mediumgray pb-3 sm:pb-5"}
            MainDiveClasses={
              "bg-white lg:bg-pastalblue text-offblack w-[300px] h-[450px] sm:w-[350px] sm:h-[650px] 2xl:w-[450px] 2xl:h-[650px] pb-5 sm:pb-10 xl:pb-[50px]"
            }
            listClasses={"pl-[30px] 2xl:pl-[50px]"}
            pricingColor={basicPlan.pricingColor}
            tagging={basicPlan.tagging}
            label={basicPlan.label}
            price={basicPlan.price}
            duration={basicPlan.duration}
            planId={basicPlan.planId}
            description={basicPlan.description}
            buttonText={"Upgrade to Basic"}
            listItems={basicPlan.listItems}
            // listItemsValue={[
            //   `${getPremiumPackageDetail?.regularListing}`,
            //   `${getPremiumPackageDetail?.featureListing}`,
            //   `${getPremiumPackageDetail?.noOfImages}`,
            // ]}
          />
        </SwiperSlide>
        <SwiperSlide>
          <PriceCard
            bottomLine={"border-b border-b-mediumgray pb-3 sm:pb-5"}
            MainDiveClasses={
              "bg-white lg:bg-pastalblue text-offblack w-[300px] h-[450px] sm:w-[350px] sm:h-[650px] 2xl:w-[450px] 2xl:h-[650px] pb-5 sm:pb-10 xl:pb-[50px]"
            }
            listClasses={"pl-[30px] 2xl:pl-[50px]"}
            pricingColor={proPlan.pricingColor}
            label={proPlan.label}
            price={proPlan.price}
            duration={proPlan.duration}
            planId={proPlan.planId}
            description={proPlan.description}
            buttonText={proPlan.buttonText}
            listItems={proPlan.listItems}
            // listItemsValue={[
            //   `${getPremiumPackageDetail?.regularListing}`,
            //   `${getPremiumPackageDetail?.featureListing}`,
            //   `${getPremiumPackageDetail?.noOfImages}`,
            // ]}
          />
        </SwiperSlide>
      </Swiper>
        <div className="flex items-center justify-center gap-x-2 mt-5">
          <CircularButton
            variant={
              location.pathname ==="/pricing"
                ? "prev30White"
                : "prev30"
            }
            onClick={() => swiperRef.current?.slideNext()}
          />
          <CircularButton
            variant={
              location.pathname ==="/pricing"
                ? "next30White"
                : "next30"
            }
            onClick={() => swiperRef.current?.slidePrev()}
          />
        </div>

    </div>
    </>
  );
};

export default PricingSlider;
